import minusesData from '@/mockData/minuses.json'

const state = {
    minusesList: minusesData,
}

const mutations = {
    ADD_MINUS(state, form) {
        state.minusesList.push(form)
    }
}

const actions = {
    addminus({ commit }, form) {
        commit('ADD_MINUS', form)
    }
}

const getters = {
    getData: state => state.minusesList
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
